import {FC} from "react";
import {Container, Item} from "./styled";
import {useTheme} from "styled-components";
import {Column, Row, Typography} from "components";
import {SvgIconComponent} from "@mui/icons-material";
import {ChevronRight, IconProps} from "react-feather";

type GroupItemData = {
  label: string;
  value: number | string;
  icon: FC<IconProps> | SvgIconComponent;
};

interface GroupItemProps {
  title: string;
  data: GroupItemData[];
}

export const GroupItem: React.FC<GroupItemProps> = ({data, title}) => {
  const {blackWhite} = useTheme();
  return (
    <Column width="100%">
      <Row gap={0}>
        <ChevronRight color={blackWhite} size={20} />
        <Typography fontSize={18} fontFamily="Rubik-Medium">
          {title}
        </Typography>
      </Row>
      <Container>
        {data.map(({value, label, icon: Icon}, key, arr) => (
          <Item key={key}>
            <Typography
              fontSize={26}
              color={blackWhite}
              zIndex={2}
              fontFamily="Rubik-Medium"
            >
              {value.toLocaleString()}
            </Typography>
            <Row>
              <Icon style={{color: blackWhite}} />
              <Typography
                fontSize={17}
                zIndex={2}
                color={blackWhite}
                fontFamily="Rubik-Medium"
              >
                {label}
              </Typography>
            </Row>
          </Item>
        ))}
      </Container>
    </Column>
  );
};
